/**
 * 如果Component不会被其他地方复用，没有必要增加文件
 */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import Clipboard from 'clipboard';
import { Page, Preload, WKDialog } from '../components';
import { LoadMore, Button, Form, FormCell, CellBody, Select, CellHeader, Label, TextArea, Input, Dialog } from 'react-weui';
import { renderMoney, isLZWKAPP, judgeAPPVersion, getAccessToken } from '../utils';
import shareImg from '../images/coupon/share-icon.png'
import { WKVisible } from '../components/wk'
import Config from '../config';
import {browserHistory} from 'react-router'

import '../css/page/CouponSharePage.css';
import config from '../config';


class CouponSharePage extends Component {
    constructor() {
        super()
        this.handleCloseNewDialog = this.handleCloseNewDialog.bind(this);
        this.handleOpenPromotionDialog = this.handleOpenPromotionDialog.bind(this);

        this.state = {
            initialized: false,
            coupon: {},
            self: {},
            promotionDialogShow: false,
            confirmStyle: [
                // noText: '关闭',
                // yesText: '确定',
                // clickNoHandle: this.handleCloseNewDialog,
                // clickYesHandle: this.handleCloseNewDialog,
                { label: '确定', onClick: () => this.handleCloseNewDialog },
                { label: '关闭', onClick: () => this.handleCloseNewDialog },
            ],
            sourceList: [],
            src_code: '',
            note: '',
            lecturerName: '',
            salespersonName: '',
            share_url: '',
            sourceURL: '',
						isBind: false,
            searchQuery: '',
            isPromotionWhiteList: false,
            isPgc: false,
            showLists: false // 新增状态，用于控制 lists 元素的显示与隐藏
        };
        this.handleShare = this.handleShare.bind(this);
        this.getSourceList = this.getSourceList.bind(this);
        this.onChangeSource = this.onChangeSource.bind(this);
        this.handleGenerateShortUrl = this.handleGenerateShortUrl.bind(this);
        this.getWhiteListBatch = this.getWhiteListBatch.bind(this);
        this.getIsPgc = this.getIsPgc.bind(this);
    }

    componentDidMount() {
        const { liveroom_id, coupon_id } = this.props.params
        axios.get(`/api/liveroom/${liveroom_id}/coupon/${coupon_id}/info`).then((res) => {
            if (res.data.code === 0) {
                const { data } = res.data
                /* 如果不是管理员，那么跳转 */
                if (!data.is_manager) {
                    window.location = data.share_info.share_url
                    return
                }
                this.setState({
                    initialized: true,
                    coupon: data.coupon,
                    self: data.self,
                    share_info: data.share_info,
                    short_url: data.short_url,
                    share_url: data.share_info.share_url
                })
                if (data.coupon.scope === 'channel') {
                    this.updateShareInfo({
                        share_title: `微课优惠券：${data.coupon.coupon_name}`,
                        share_description: `价值${renderMoney(data.coupon.price)}元！快抢`,
                        share_icon: shareImg,
                        share_url: data.share_info.share_url,
                    })
                } else {
                    this.updateShareInfo(data.share_info)
                }
            } else {
                this.props.dispatch({
                    type: 'ERROR_SHOW',
                    payload: {
                        tips: res.data.msg
                    }
                })
            }
        }).catch((error) => {
            this.props.dispatch({
                type: 'ERROR_SHOW',
                payload: {
                    tips: '读取错误：' + error
                }
            })
        })

        this.getWhiteListBatch({
            liveroom_id,
            batch: {
                is_promotion_whitelist: {
                    server_name: 'liveroom_model',
                    key: 'promotion_whitelist',
                },
            },
        })
				this.getBindPromoteInfo()
        // this.getIsPgc(liveroom_id)

    }

    getSourceList() {
        const { liveroom_id } = this.props.params
        axios.get('/v1/integration/cont_manager/v1/api/order_source.by_liveroom.list_get', {
            baseURL: config.BASE_URL_ELSE,
            params: {
                limit: 1000,
                offset: 0,
                liveroom_id,
                token: localStorage.getItem('Session/token')
            }
        }).then((res) => {
            if (res.data.code === '0000') {
                const { data_list } = res.data.data
                this.setState({ sourceList: data_list });
            }
        }).catch(console.error)
    }

    updateShareInfo(share_info) {
        // init sharedata
        this.props.dispatch({
            type: 'UPDATE_SHARE_DATA',
            payload: {
                title: share_info.share_title,
                desc: share_info.share_description,
                imgUrl: share_info.share_icon,
                type: 'link',
                link: share_info.share_url
            }
        })

        let clipboard = new Clipboard('#button_copy');
        clipboard.on('success', (e) => {
            this.setState({ promotionDialogShow: false });
            this.page.showAlert('已复制到剪贴板');
            e.clearSelection();
        });
    }

    handleShare() {
        const { share_info } = this.state;
        if (window.systemType === 'ios') {
            let dic = {
                function: 'shareUrl',
                json: share_info
            };
            window.webkit.messageHandlers.WKApp.postMessage(dic);
        }

        if (window.systemType === 'android') {
            WKApp.shareUrl(share_info.share_title, share_info.share_description, share_info.share_url, share_info.share_icon);
        }
    }

    handleCloseNewDialog() {
        this.setState({ promotionDialogShow: false });
    }
    handleOpenPromotionDialog() {
        this.getSourceList()
        this.setState({ promotionDialogShow: true });
    }

    handleGenerateShortUrl(value) {
        const { liveroom_id } = this.props.params
        axios.get(`/api/liverooms/${liveroom_id}/get_short_url`, {
            baseURL: config.WK_ADMIN_API,
            params: {
                url: this.state.share_url + `&ord_sc=${value}`,
                token: localStorage.getItem('Session/token')
            }
        }).then((res) => {
            if (res.data.code === 0) {
                console.log(res.data.data.short_url)
                this.setState({ sourceURL: res.data.data.short_url })
            }
        }).catch(console.error)
    }

		getBindPromoteInfo(){
			axios.get('/v1/integration/cont_manager/v1/api/liveroom.values.get', {
					baseURL: Config.BASE_URL_ELSE,
					params: {
						liveroom_id: this.props.params.liveroom_id,
						using_order_source: true,
						token: getAccessToken()
					}
			}).then(({data}) => {
				this.setState({isBind: data && data.data && data.data.using_order_source})
				}).catch(console.error)
			}


    onChangeSource(e) {

        const value = e.target.value
        const sourceItem = this.state.sourceList.find(source => source.src_code === value)
        this.setState({ src_code: value, note: sourceItem.note, lecturerName: sourceItem.lecturer_name, salespersonName: sourceItem.salesperson_name  })
        this.handleGenerateShortUrl(value)
    }
    onClickSource(item) {
        this.setState({
            src_code: item.src_code,
            note: item.note,
            lecturerName: item.lecturer_name,
            salespersonName: item.salesperson_name,
            searchQuery: item.name
        })
        this.handleGenerateShortUrl(item.src_code)
    }
    getIsPgc(liveroom_id){
        axios.get('/v1/integration/wk_staff/outer/organization.is_in_pgc.get', {
          baseURL: Config.BASE_URL_ELSE,
          params: {
            org_code: liveroom_id,
            sys_name: 'wk_staff',
            token: localStorage.getItem('Session/token')
          }
      }).then(({data}) => {
        this.setState({isPgc: data && data.data && data.data.is_pgc_liverooms})
        }).catch(console.error)
      }


    getWhiteListBatch(params) {
        try {
            const token = getAccessToken();
            axios
                .post(
                    `${config.gateway_root_url}/config/check_whitelist_batch?version=1.0`,
                    params,
                    { headers: { 'Content-Type': 'application/json' }, params: { token } },
                )
                .then(res => {
                    this.setState({ isPromotionWhiteList: res.data.data.is_promotion_whitelist })
                })
                .catch(err => {
                    console.log(err)
                })
        } catch (e) {
            console.error(e.message);
        }
    }
    renderPromotionLink() {
        return (
            <div className="link">
                <p onClick={this.handleOpenPromotionDialog}>推广链接</p>
            </div>
        );
    }

    renderShortUrlLink(short_url) {
        return (
            <div className="link">
                <p>{short_url}</p>
                <p id="button_copy" data-clipboard-text={short_url}>普通链接</p>
            </div>
        );
    }


    render() {
        // console.log(this.props)
        const { wechat } = this.props;

        if (!this.state.initialized) {
            return <Preload />
        }

        const { coupon, share_info } = this.state;
        const { short_url, promotionDialogShow, sourceList, src_code, note, isPromotionWhiteList, lecturerName, salespersonName, isPgc } = this.state;

        let shouldShowCoupon = isLZWKAPP() && ((window.systemType === 'ios' && judgeAPPVersion(360)) || (window.systemType === 'android' && judgeAPPVersion(260)));

        if (window.platform === 'weixin') {
            if (!wechat.ready || wechat.shareData.link !== share_info.share_url) {
                return <Page parent={this}>
                    <p style={{ color: "#fff", textAlign: "center", marginTop: "100px" }}>正在初始化JSSDK，请稍后...</p>
                    <LoadMore loading></LoadMore>
                </Page>
            }
        }


        return (
            <Page parent={this}>
                <div className="coupon-share-page">
                    <div className="box discount-share">
                        <div className="discount-lecture">
                            <p className="text-center">{coupon.object_name}</p>
                            <span className="line-circle left-circle" />
                            <span className="line-circle right-circle" />
                        </div>
                        <div className="discount-price">
                            <WKVisible create={coupon.threshold_enabled}>
                                <p className="text-center">{coupon.scope_name}（满￥{renderMoney(coupon.threshold_price)}可用）</p>
                            </WKVisible>
                            <WKVisible create={!coupon.threshold_enabled}>
                                <p className="text-center">{coupon.scope_name}</p>
                            </WKVisible>
                            <p className="discount-price-val">¥{renderMoney(coupon.price)}</p>
                        </div>
                        <div className="discount-rules">
                            <p className="discount-rules-title">使用规则</p>
                            {window.platform === 'weixin' ?
                                <p>1. 点击右上角，分享给好友</p>
                                :
                                <p>1. 点击下面“{isPromotionWhiteList ? '推广链接或者普通链接' : '普通链接'}”按钮，分享给好友</p>
                            }
                            <p>2. 好友点击你分享的链接后即可领取优惠券</p>
                        </div>


                        <div className="discount-link" style={{ height: shouldShowCoupon ? '150px' : 'auto' }}>
                            <div className="title">
                                获取短链接
                            </div>
                            <div className="content">
                                {isPromotionWhiteList
                                    ? <div>
                                        {
                                            this.state.isBind
                                                ? this.renderPromotionLink()
                                                :
                                                <div >
                                                    {this.renderPromotionLink()}
                                                    {this.renderShortUrlLink(short_url)}
                                                </div>
                                        }
                                    </div>
                                    : this.renderShortUrlLink(short_url)}
                            </div>
                            {shouldShowCoupon &&
                                <div className="button">
                                    <Button className="button-share" onClick={this.handleShare}>分享优惠券</Button>
                                </div>
                            }
                        </div>
                    </div>
                </div>
                <Dialog type="ios" title='推广链接获取' show={promotionDialogShow} buttons={[
                    { label: '关闭', onClick: () => this.handleCloseNewDialog() }
                ]} >
                    <Form>
                        <div className="new-promotion-dialog-lable">选择推广渠道</div>
                        {/* 添加搜索框 */}
                        <div style={{position: 'relative', height: '50px'}}>

                            <FormCell  className="new-promotion-dialog-searchIpt">
                                <CellBody>
                                    <Input
                                        value={this.state.searchQuery}
                                        type="text"
                                        placeholder="搜索推广渠道"
                                        onChange={(e) => {
                                            this.setState({
                                                searchQuery: e.target.value,
                                                src_code: '',
                                                note: '',
                                                lecturerName: '',
                                                salespersonName: ''
                                            })
                                        }}
                                        onFocus={() => {
                                            this.setState({ showLists: true }); // 输入框聚焦时显示 lists
                                        }}
                                        onBlur={() => {
                                            setTimeout(() => {
                                                this.setState({ showLists: false }); // 输入框失去聚焦时隐藏 lists
                                            }, 300)
                                        }}
                                    />
                                </CellBody>
                            </FormCell>

                            {/* <FormCell  style={{position: 'absolute', left: 0}} select>
                                <CellBody>
                                    <Select ref={this.setSelectRef} value={src_code} className="new-promotion-dialog-select" onChange={e => { this.onChangeSource(e) }}>
                                        <option value=''></option>
                                        {sourceList.filter(sources => {
                                            const query = this.state.searchQuery || '';
                                            return sources.name.toLowerCase().includes(query.toLowerCase());
                                        }).map(sources => {
                                            return <option key={sources.src_code} value={sources.src_code}>{sources.name}</option>
                                        })}
                                    </Select>
                                </CellBody>
                            </FormCell> */}
                            <div className='lists' style={{display: this.state.showLists ? 'block' : 'none', maxHeight: '100px'}} >
                                {sourceList.filter(sources => {
                                    const query = this.state.searchQuery || '';
                                    return sources.name.toLowerCase().includes(query.toLowerCase());
                                }).map(sources => {
                                    return <div key={sources.src_code} onClick={() => {this.onClickSource(sources)}} className='list-item'>{sources.name}</div>
                                })}
                            </div>
                        </div>
                        {
                            lecturerName && (
                                <div>
                                    <div className="new-promotion-dialog-lable">{`销转讲师`}</div>
                                    <FormCell className="new-promotion-dialog-textarea">
                                        <CellBody>
                                            <Input
                                                value={lecturerName}
                                            >
                                            </Input>
                                        </CellBody>
                                    </FormCell>
                                </div>
                            )
                        }
                       {
                            salespersonName && (
                                <div>
                                     <div className="new-promotion-dialog-lable">销售人员</div>
                                    <FormCell className="new-promotion-dialog-textarea">
                                        <CellBody>
                                            <Input
                                                value={salespersonName}
                                            >
                                            </Input>
                                        </CellBody>
                                    </FormCell>
                                </div>
                            )
                       }
                        {
                            note && (
                                <div>
                                    <div className="new-promotion-dialog-lable">渠道备注</div>
                                    <FormCell className="new-promotion-dialog-textarea">
                                        <CellBody>
                                            <TextArea
                                                value={note}
                                                rows="3"
                                                showCounter={false}
                                            >
                                            </TextArea>
                                        </CellBody>
                                    </FormCell>
                                </div>
                            )
                        }
                        <div className="new-promotion-dialog-lable">推广链接</div>
                        <FormCell className="new-promotion-dialog-textarea">
                            <CellBody>
                                <Input value={this.state.sourceURL} placeholder="请选择推广渠道" />
                                <div className="new-promotion-dialog-cpoy-btn" id="button_copy" data-clipboard-text={this.state.sourceURL}>一键复制</div>
                            </CellBody>
                        </FormCell>
                    </Form>
                </Dialog>
            </Page>
        )
    }
}


export default connect((state) => ({
    wechat: state.wechat
}))(CouponSharePage)



// WEBPACK FOOTER //
// ./src/pages/CouponSharePage.js